export function geCSVColumns(row, csvColumnNames, resultSet) {
    let columnNames = csvLineToList_(csvColumnNames);
    let values = [];
    for (let columnName of columnNames) {
        values.push(getByColName(row, columnName, resultSet));
    }
    return values;
}

export function getByColName(row, column, resultSet) {
    let index = resultSet.rows[0].values.indexOf(column);
    if (index < 0)
        return "";
    return getByIndex(row, index, resultSet);
}

export function resultSetSize(resultSet) {
    return resultSet.rows.length - 1;
}

export function getByIndex(row, index, resultSet) {
    return get(row, resultSet)[index];
}

export function get(i, resultSet) {
    if (i + 1 >= resultSet.rows.length)
        return [];
    return resultSet.rows[i + 1].values;
}


function csvLineToList_(seperator, csv, trim, addEmpty) {
    return csvLineToList(",", csv, trim, addEmpty);
}

export function csvLineToList(seperator, csv, trim, addEmpty) {
    if (!csv)
        csv = "";
    let parts = csv.split(seperator);
    let list = [];
    for (let part of parts) {
        if (trim)
            part = part.trim();
        if (addEmpty || part)
            list.push(part);
    }
    return list;
}